/** 
 * api接口统一管理
 */
import {get, post } from './request'

const ApiAddress = {
    // 分页获取博客列表
    getBlogByPage: function(params) {
        return post("/api/article/list", params);
    },

    // 获取一条博客的详情
    getBlogInfo: function(params) {
        return post("/api/article/info", params);
    },

    // 全文搜索博客
    searchBlog: function(params) {
        return post("/api/article/es/search", params);
    },
}

export default ApiAddress;


// WEBPACK FOOTER //
// ./src/api/api.js